import { Component, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'editable-input',
  templateUrl: 'editable-input.component.html',
  styleUrls: ['./editable-input.component.sass'],
  host: { class: 'am-flex-align gap-xs' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditableInputComponent {
  @Input() editBox: string;
  @Input() index: string;
  @Input() type: string;
  @Input() maxValue: number;
  @Input() value: string | number;
  @Input() valueType: string;
  @Input() postValue: string;
  @Input() showEdit: boolean;
  @Output() onValueChange = new EventEmitter<any>();
  @Output() toggleEditBox = new EventEmitter<any>();

  tempValue:      string | number;
  tempInputValue: string | number;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.value) this.resetInput(changes.value.currentValue);
    if (changes && changes.editBox) this.editBox = changes.editBox.currentValue;
    if (changes && changes.showEdit && changes.showEdit.currentValue === false) this.value = this.tempValue;
  }

  onInput(e) {
    if (this.type === 'number') {
      let temp = e.target.value.toString().replace(',','.').split('.');
      if (this.maxValue && parseFloat(e.target.value) > +this.maxValue) e.target.value = this.tempInputValue;
      else if (temp[1] !== undefined && temp[1] !== null) e.target.value = [temp[0], temp[1].substring(0, 2)].join('.');
      this.tempInputValue = e.target.value;
    }
  }

  onKeyDown(e: KeyboardEvent): void {
    let allowedKeys = [',', '.'];
    if (this.type === 'number'  &&
      !(e.code === 'Backspace') &&
      !(e.code === 'Delete'   ) &&
      !allowedKeys.some(k => k === e.key) && isNaN(parseFloat(e.key))) e.preventDefault();
  }

  onBlur(e): void {
    if (this.valueType === 'currency') {
      e.target.value = parseFloat(e.target.value.replace(',','.')).toFixed(2)+''.replace('.',',');
      this.onValueChange.emit(e.target.value);
    } else if (this.valueType === 'distance') {
      e.target.value = parseFloat(e.target.value.replace(',','.')).toFixed(1)+''.replace('.',',');
      this.onValueChange.emit(e.target.value);
    } else this.onValueChange.emit(this.formatByTypeForPreview(e.target.value));
    this.toggleEditBox.emit(null);
  }

  toggleEditableInput(index: string): void {
    this.editBox = this.editBox === index ? null : index;
    if (this.editBox !== null) {
      setTimeout(() => {
        let el: HTMLInputElement = document.querySelector(`#edit-field-${this.editBox}`);
        if (this.valueType === 'currency') el.value = parseFloat(this.value+'') ? this.formatByTypeForPreview(this.value)+'' : '';
        if (this.type === 'number') {
          el.step = '0.1';
          el.min = "0";
        }
        el.focus();
        if (window.document['documentMode']) el.value = '';
      });
    }
    this.toggleEditBox.emit(this.editBox);
  }

  private resetInput(value): void {
    this.tempInputValue = value;
    this.tempValue = value;
    this.value = value;
  }

  formatByTypeForPreview(value): string | number {
    switch (this.valueType) {
      case 'currency':
        return value !== null      &&
               value !== undefined && (
                value === 0      ||
                value === '0'    ||
                value === '0.00' ||
                value === '0,00' ||
                value === '0,0'  ||
                value === '0.0'  ||
              parseFloat(value)
              ) ? parseFloat(value+'').toFixed(2).replace('.', ',')
                : '-';
      case 'distance':
        return parseFloat(value+'').toFixed(1).replace('.', ',');
      case 'text':
        return value + '';
      case 'number':
        return +value;
      default:
       return value;
    }
  }

}
